import { MobileNavItem } from "./MobileNavItem";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import type { NavigationModel } from "@lib/contentful/mappers/mapNavigation";
import { mobileMenuContainerStyles } from "@components/layouts/navigation/styles";
import { useState } from "react";

export interface MobileNavProps {
    navigation: NavigationModel;
}

export const MobileNav = ({ navigation }: MobileNavProps) => {
    const [parentMenuBg, setParentMenuBg] = useState(false);

    const handleFirstMenuBgColor = () => {
        setParentMenuBg(!parentMenuBg);
    };

    return (
        <>
            <Box>
                <Flex
                    bg={parentMenuBg ? "transparent" : "white"}
                    transition={parentMenuBg && "background-color .2s .1s"}
                    sx={mobileMenuContainerStyles}
                >
                    {navigation.items.map((navigationItem) => (
                        <MobileNavItem
                            key={navigationItem.id}
                            navigationItem={navigationItem}
                            handleFirstMenuBgColor={handleFirstMenuBgColor}
                        />
                    ))}
                </Flex>
            </Box>
        </>
    );
};
